import Head from "next/head";

import SignUp from "../../src/accounts/components/signup/SignUp";
import AuthPageBase from "../../src/accounts/components/common/AuthPageBase";
import { SERVER } from "../../src/common/config/utils";
import { SITE_NAME } from "../../src/common/config/seo";

export default function () {
  return (
    <>
      <Head>
        <title>Sign Up | {SITE_NAME}</title>
        <meta
          name="description"
          content={`Create your account on ${SITE_NAME}`}
        />
        <link rel="canonical" href={`${SERVER}/accounts/signup`} />
        <meta property="og:url" content={`${SERVER}/accounts/signup`} />
        <meta property="og:title" content={`Sign Up | ${SITE_NAME}`} />
        <meta
          property="og:description"
          content={`Create your account on ${SITE_NAME}`}
        />
        <meta
          property="og:image"
          content={`${SERVER}/accounts/signup-og-image.png`}
        />
        {/* twitter tags */}
        <meta property="twitter:url" content={`${SERVER}/accounts/signup`} />
        <meta name="twitter:title" content={`Sign Up | ${SITE_NAME}`} />
        <meta
          name="twitter:description"
          content={`Create your account on ${SITE_NAME}`}
        />
        <meta
          name="twitter:image"
          content={`${SERVER}/accounts/signup-og-image.png`}
        />
        <script
          src="https://challenges.cloudflare.com/turnstile/v0/api.js"
          async
          defer
        ></script>
      </Head>
      <AuthPageBase
        title="Let's get you started"
        oAuthButtonText="Sign up with"
      >
        <SignUp />
      </AuthPageBase>
    </>
  );
}
